import PanelQuinielasPrivadas from './PanelQuinielasPrivadas';
export default PanelQuinielasPrivadas;
